import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { IconsModule } from './shared/design-system/icons/icons.module';
import { provideClientHydration } from '@angular/platform-browser';
import { GtmService } from './shared/services/tracking/gtm.service';

registerLocaleData(localeFr);

export function gtmInitializer(gtmService: GtmService) {
  return () => gtmService.init();
}

// a décommenter lors de l'initialisation via appel api

// export function initFeatureFlags(ff: FeatureFlagService) {
//   return () => ff.init().catch(() => []); // ne bloque pas l'app si erreur
// }

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(withFetch()),
    provideRouter(routes),
    importProvidersFrom(IconsModule),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    {
      provide: APP_INITIALIZER,
      useFactory: gtmInitializer,
      deps: [GtmService],
      multi: true,
    },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initFeatureFlags,
    //   deps: [FeatureFlagService],
    //   multi: true,
    // },
  ],
};
